import { useQuery } from '@tanstack/react-query';
import { publicFetch } from '../../utils/authenticatedFetch';
import CONFIG from '../../config/config';

/**
 * Batch-fetches news for a list of stock symbols from the news API.
 * Returns a map of { SYMBOL: [{ title, source, url, publishedAt }] }.
 * Uses placeholderData to keep previous results visible while refetching on scroll.
 */
export const useStockNews = (symbols) => {
  return useQuery({
    queryKey: ['batchStockNews', symbols?.length || 0],
    queryFn: async () => {
      if (!symbols?.length) return {};
      const resp = await publicFetch(`${CONFIG.API_URLS.NEWS}?symbols=${symbols.join(',')}&days=7`);
      const json = await resp.json();
      console.log('[EARNINGS-NEWS] fetched news for', symbols.length, 'symbols,', Object.keys(json.newsMap || {}).length, 'had articles');
      return json.newsMap || {};
    },
    enabled: !!symbols?.length,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    placeholderData: (prev) => prev, // keep page-1 data while page-2 refetches
  });
};
